module.exports = __webpack_public_path__ + "img/seed_inspect_book.b7554801.png";